// @ts-strict-ignore
// Calls to localStorage will fail in Safari Private Browsing so we have to protect against that
// Modified based on https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API#Testing_for_availability

export type Storage = "localStorage" | "sessionStorage";

let storageIsEnabled;

function isStorageSupported(type: Storage) {
  if (storageIsEnabled !== undefined) {
    return storageIsEnabled;
  }
  const testKey = "test";
  let storage;
  try {
    // Try setting a test value
    storage = window[type];
    storage.setItem(testKey, "1");
    storage.removeItem(testKey);
    storageIsEnabled = true;
  } catch (e) {
    storageIsEnabled =
      (e.code === 22 ||
        e.code === 1014 ||
        e.name === "QuotaExceededError" ||
        e.name === "NS_ERROR_DOM_QUOTA_REACHED") &&
      storage &&
      storage.length !== 0;
  } finally {
    return storageIsEnabled;
  }
}

const storageSupported = (type: Storage) => isStorageSupported(type);

const getItem = (item: string, type: Storage = "localStorage") => {
  let value;
  if (storageSupported(type)) {
    value = window[type].getItem(item);
  }
  return value;
};

const removeItem = (item: string, type: Storage = "localStorage") => {
  storageSupported(type) ? window[type].removeItem(item) : true;
};

const setItem = (
  item: string,
  value: string | number | boolean,
  type: Storage = "localStorage"
) =>
  storageSupported(type) ? window[type].setItem(item, value.toString()) : true;

export default {
  get: getItem,
  set: setItem,
  remove: removeItem
};
